import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ value, onChange, placeholder = "Password", testid = "password-input", required, minLength, className = "" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} value={value} onChange={onChange} placeholder={placeholder}
        data-testid={testid} required={required} minLength={minLength}
        className={`eyw-input w-full pr-11 ${className}`} />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-[#8FA89B] hover:text-[#144F75]">
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
